// 기본 에러 팝업 아이콘은 오프라인 첫 렌더에서도 떠야 하므로 번들에 인라인(별도 파일 fetch 없음, #419).
import caution from "@/assets/icons/common/caution.png?inline";
import forbidden from "@/assets/icons/common/forbidden.png";
import clock from "@/assets/icons/common/clock.png";
import fail from "@/assets/icons/common/fail.png";
import success from "@/assets/icons/common/success.png";
import email from "@/assets/icons/common/email.png";

/**
 * AlertDialog(에러 팝업) 공통 아이콘 소스 — 스토어 경로(AlertDialogHost 기본값)와
 * 직접 사용처(`<AlertDialog icon={...} />`)가 이 모듈을 공통 참조해 아이콘 소스를 단일화한다.
 *
 * 아이콘 사용 정의 (6분류):
 * - `cautionIcon`(⚠️ 주의): 기본 에러 팝업. AlertDialogHost 가 icon 미지정 시 기본값으로 사용.
 * - `forbiddenIcon`(🚫 금지): 차단·정지·탈퇴 등 차단성 케이스에서 호출처가 명시 전달.
 * - `clockIcon`(⏱️ 시계): 인증시간/유효시간/세션 만료·초과 케이스.
 * - `failIcon`(❌ 실패): 로그인 실패 / 찾는 값이 없거나 조회 실패 케이스.
 * - `successIcon`(✅ 성공): 성공 결과 시트 등 성공 케이스.
 * - `emailIcon`(✉️ 이메일): 이메일 인증번호 불일치·이메일 중복 등 이메일 관련 에러.
 */
export const cautionIcon = caution;
export const forbiddenIcon = forbidden;
export const clockIcon = clock;
export const failIcon = fail;
export const successIcon = success;
export const emailIcon = email;
